import { render } from "./StatusLamp.vue?vue&type=template&id=1788c17b"
import script from "./StatusLamp.vue?vue&type=script&lang=js"
export * from "./StatusLamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__